import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators, FormGroup, AbstractControl} from '@angular/forms';
import {ImageCropperComponent, CropperSettings} from "ng2-img-cropper"
import { UserProfileModel } from "./userprofile.model";
import { UserProfileService } from "./userprofile.service";
import { AppState } from "../../../app.service";
import { AlertService } from "../../../services/index";
import { ImageUploadService } from "../../../services/Common/imageupload.service";

@Component({
    selector: 'profile',
    template: require('./profile.template.html'),
    providers: [UserProfileService],
})

export class ProfileComponent implements OnInit {
    data: any;
    cropperSettings: CropperSettings;
    userProfile: UserProfileModel;
    userProfileForm: FormGroup;
    imageUrl: string;
    fileName: string;

    @ViewChild('cropper', undefined) cropper: ImageCropperComponent;

    constructor(private userProfileService: UserProfileService, fb: FormBuilder, private appState: AppState, private alertService: AlertService, private imageUploader: ImageUploadService) {
        this.imageUrl = this.appState.getCookie("imageUrl");
        this.userProfileForm = fb.group({
            'userId': null,
            'username': null,
            'firstname': [null, Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z\-\']+')])],
            'middlename': null,
            'lastname': [null, Validators.required],
            'emailAddress': [null, Validators.compose([Validators.required, Validators.pattern('^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$')])],
            'mobileNumber': [null, Validators.compose([Validators.required, Validators.pattern('^[0-9]+$')])],
            'password': null,
            'imageUrl': null,
            'confirmPassword': null
        }, {
            validator: this.MatchPassword
        });
        this.data = {};
        this.cropperSettings = new CropperSettings();
        this.cropperSettings.width = 200;
        this.cropperSettings.height = 200;
        this.cropperSettings.keepAspect = false;

        this.cropperSettings.croppedWidth = 200;
        this.cropperSettings.croppedHeight = 200;

        this.cropperSettings.canvasWidth = 500;
        this.cropperSettings.canvasHeight = 300;

        this.cropperSettings.minWidth = 100;
        this.cropperSettings.minHeight = 100;

        this.cropperSettings.rounded = true;
        this.cropperSettings.minWithRelativeToResolution = false;

        this.cropperSettings.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
        this.cropperSettings.cropperDrawSettings.strokeWidth = 2;
        this.cropperSettings.noFileInput = true;
    }

    ngOnInit() {
        this.getUserProfile();
    }

    MatchPassword(AC: AbstractControl) {
        let password = AC.get('password').value; // to get value in input tag
        let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
        if (confirmPassword != null && confirmPassword.length > 0 && password != confirmPassword) {
            AC.get('confirmPassword').setErrors({MatchPassword: true})
        }
        else if (password != null && password.length > 0 && (confirmPassword == null || confirmPassword.length == 0)) {
            AC.get('confirmPassword').setErrors({required: true});
        }
        else {
            AC.get('confirmPassword').setErrors(null);
        }
    }

    getUserProfile() {
        this.userProfileService.getUserProfile().subscribe(
            data => {
                this.userProfile = UserProfileModel.fromJson(data);
                this.userProfileForm.setValue(this.userProfile);
                if (data.ImageUrl != null && data.ImageUrl != '') {
                    if (this.imageUrl != data.ImageUrl) {
                        this.appState.setCookie("imageUrl", data.ImageUrl);
                    }
                    this.imageUrl = data.ImageUrl;
                }
            }
        );
    }

    validateAndUpdateProfile(userProfile: UserProfileModel) {
        var ext = this.fileName.substring(this.fileName.lastIndexOf("."));
        if (this.data.image !== undefined) {
            this.imageUploader.uploadImage(this.data, "AvatarImage", userProfile.userId + ext).subscribe(
                data => {
                    this.alertService.success("Profile image updated successfully");
                    console.log(data);
                    userProfile.imageUrl = data[0];
                    this.userProfileService.updateUserProfile(userProfile).subscribe(
                        data => {
                            this.alertService.success("Profile updated successfully");
                            this.getUserProfile();
                        },
                        err => {
                            this.alertService.error(err.Message);
                        });
                },
                err => {
                    var data = err.json();
                    console.log(data);
                    this.alertService.error("Error uploading new profile image: " + data.Message);
                });
        } else {
            this.userProfileService.updateUserProfile(userProfile).subscribe(
                data => {
                    this.alertService.success("Profile updated successfully");
                    this.getUserProfile();
                },
                err => {
                    this.alertService.error(err.Message);
                }
            );
        }
    }

    fileChangeListener($event) {
        var image: any = new Image();
        var file: File = $event.target.files[0];
        this.fileName = file.name;
        var myReader: FileReader = new FileReader();
        var that = this;
        myReader.onloadend = function (loadEvent: any) {
            image.src = loadEvent.target.result;
            that.cropper.setImage(image);

        };

        myReader.readAsDataURL(file);
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/account/profile/profile.component.ts